import React, { useEffect } from 'react';
import * as sharingLinkActions from '../actions';
import { Form, Input, Modal, Spin } from '@myua/kit';
import { useSelector, useDispatch } from 'react-redux';
import { getLinkModal } from '../selectors';
import { SharingLink } from '../../../api';

enum FieldKey {
  id = 'id',
  name = 'name',
}

export const LinkModal = () => {
  const dispatch = useDispatch();
  const linkModal = useSelector(getLinkModal);

  const [form] = Form.useForm<Pick<SharingLink, FieldKey>>();

  const { visible, link, inProgress } = linkModal;
  useEffect(() => {
    if (visible) {
      form.resetFields();
      if (link) {
        form.setFieldsValue(link);
      }
    }
  }, [visible, link, form]);

  const onOk = () => {
    if (inProgress) {
      return;
    }
    form
      .validateFields()
      .then((values) => {
        dispatch(sharingLinkActions.linkModalSubmitted(values));
      })
      .catch(
        (error) => console.log(error), // eslint-disable-line no-console
      );
  };

  const onCancel = () => {
    if (inProgress) {
      return;
    }
    dispatch(sharingLinkActions.linkModalSetVisible({ visible: false }));
  };

  return (
    <Modal
      open={visible}
      title="Edit"
      onOk={onOk}
      confirmLoading={inProgress}
      onCancel={onCancel}
      cancelButtonProps={{ disabled: inProgress }}
    >
      <Spin spinning={inProgress}>
        <Form form={form} validateMessages={{ required: 'Required field' }}>
          <Form.Item hidden name={FieldKey.id}>
            <Input />
          </Form.Item>
          <Form.Item name={FieldKey.name} label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};
